module.exports = "https://cdn.hellotech.com/client-assets/universal_remotes_mobile_2666f9bdd16a6f497a1550cb98551743.png";